import React from "react";

function CheckIcon() {
  return (
    <span className="anticon anticon-check">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 12 9"
      >
        <g fill="none" fillRule="evenodd">
          <g fill="currentColor">
            <g>
              <path
                d="M7.86 11.605l6.418-6.314c.394-.388 1.033-.388 1.427 0 .393.387.393 1.015 0 1.403l-7.131 7.015c-.394.388-1.032.388-1.426 0l-2.853-2.806c-.393-.387-.393-1.016 0-1.403.394-.387 1.033-.387 1.427 0l2.139 2.105z"
                transform="translate(-109 -158) translate(105 153)"
              />
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
}

export default CheckIcon;
